import React from 'react'
import styled from 'styled-components'
import { TextAlignment } from '@modules/common/models/enums'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'

interface IProps {
  alignment?: TextAlignment
  fontSize?: string
  cellPadding?: string
  value?: string
  onClick?: any
  verticalAlign?: string
  disabled?: boolean
  fontColor?: any
  isBold?: boolean
}

const StyledSpan = styled.span<Partial<{ fontSize; alignment; fontColor; fontWeight }>>(
  props => {
    return {
      font: props.fontSize ? props.fontSize : 'var(--typography-body3)',
      textAlign: props.alignment,
      width: '100%',
      color: props.fontColor ? props.fontColor : 'black',
      fontWeight: props.fontWeight || 'normal'
    }
  }
)

const StyledTypography = styled.span<Partial<{ fontSize; alignment; fontColor }>>(
  props => {
    return {
      textAlign: props.alignment,
      width: '100%'
    }
  }
)

const Root = styled.div<IProps>(props => {
  return {
    height: '100%',
    padding: props.cellPadding ? props.cellPadding : 'var(--cell-padding)',
    display: 'flex',
    alignItems: props.verticalAlign ? props.verticalAlign : 'center',
    justifyContent: props.verticalAlign ? props.verticalAlign : 'center'
  }
})

export const StatusComponent: React.FunctionComponent<IProps> = React.memo(
  (props: IProps) => {
    const {
      alignment,
      value,
      cellPadding,
      fontSize,
      onClick,
      verticalAlign,
      disabled,
      fontColor,
      isBold
    } = props
    return (
      <Root cellPadding={cellPadding} verticalAlign={verticalAlign} disabled={disabled}>
        {onClick ? (
          <Button disabled={disabled} onClick={onClick}>
            <StyledSpan
              fontSize={fontSize}
              fontWeight={500}
              alignment={alignment}
              fontColor={fontColor}
            >
              {value.toUpperCase()}
            </StyledSpan>
          </Button>
        ) : (
          <StyledTypography alignment={alignment}>
            <Tooltip title={value}>
              <StyledSpan
                fontSize={fontSize}
                alignment={alignment}
                fontColor={fontColor}
                fontWeight={isBold ? 'bold' : 'normal'}
              >
                {value.toUpperCase()}
              </StyledSpan>
            </Tooltip>
          </StyledTypography>
        )}
      </Root>
    )
  }
)
